import { namespacer } from 'helpers'

const namespace = namespacer('MEMBER_MAILCHIMP_SUBSCRIBE_FORM')

export const SUBSCRIPTION_SUCCESS = namespace('SUBSCRIPTION_SUCCESS')
